export const txtGiveTitle = {
  id: "Kirim Hadiah",
  en: "Wedding Gift",
};

export const txtGiveDescription = {
  id: "Kehadiran keluarga dan teman terkasih merupakan kado terindah bagi kami, namun jika Anda ingin memberi tanda kasih, silakan kirim ke rekening berikut ini:",
  en: "Your presence is the greatest gift to us, but if you’d like to share more blessings, you can do it through:",
};

export const txtGiveDescriptionX = {
  id: "Kehadiran keluarga dan teman terkasih merupakan kado terindah bagi kami, namun jika Anda ingin memberi tanda kasih, mohon untuk dikonfirmasikan terlebih dahulu kepada kami. Terima kasih!",
  en: "The presence of family and dear friends is the most beautiful gift for us, but if you wish to express your love through a present, please kindly confirm it with us beforehand. Thank you!",
};

export const txtGiveNote = {
  id: "Mohon maaf, dikarenakan keterbatasan tempat penyimpanan, kami hanya menerima hadiah berupa uang tunai melalui rekening di atas. Terima kasih!",
  en: "We sincerely apologize, due to our limited space, we kindly request gifts in the form of monetary contributions through the above mentioned accounts. Thank you for your understanding and support!",
};

export const txtConfirmationButton = {
  id: "Konfirmasi hadiah",
  en: "Please confirm your gift here!",
};

export const txtCopyButton = {
  id: "Salin",
  en: "Copy",
};

export const txtCopied = {
  id: "Tersalin",
  en: "Copied",
};
